interface SelfServiceError {
    field: string;
    reason: string;
}

export const useSelfServiceUrl = (section?: string | null, errors?: SelfServiceError[] | null) => {
    const runtimeConfig = useRuntimeConfig();
    const route = useRoute();

    return computed(() =>
        getSelfServiceUrl(
            runtimeConfig.public.baseUrl,
            route.fullPath,
            runtimeConfig.public.keycloakUrl,
            section,
            errors
        )
    );
};

interface SelfServiceUrlOptions {
    /**
     * Where the user lands after saving, if not back on `currentPath`. The consent flow uses it to
     * reach the waiting page, since the account is still inactive when the user returns.
     */
    postsaveRedirectTo?: string;
}

export const getSelfServiceUrl = (
    baseUrl: string,
    currentPath: string,
    keycloakUrl: string,
    section: string | null = null,
    errors: SelfServiceError[] | null = [],
    options: SelfServiceUrlOptions = {}
) => {
    const postsaveCallback = new URL(`/api/auth/refresh`, baseUrl);
    postsaveCallback.searchParams.set('redirect_to', options.postsaveRedirectTo ?? currentPath);

    const selfService = new URL(`/self-service/${section || ''}`, keycloakUrl);
    selfService.searchParams.set('postsave-callback', postsaveCallback.toString());
    selfService.searchParams.set('error', btoa(JSON.stringify(errors)));

    return selfService.toString();
};
